module.exports = __webpack_public_path__ + "media/images/sidebar-dashboard-786f76fa6050c0a46dcbc71b57bcd86b.svg";